/* tslint:disable */
/* eslint-disable */
/**
 * Leads API
 * API for managing leads (potential customers from external sources)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CoverageDetailDto } from './CoverageDetailDto';
import {
    CoverageDetailDtoFromJSON,
    CoverageDetailDtoFromJSONTyped,
    CoverageDetailDtoToJSON,
    CoverageDetailDtoToJSONTyped,
} from './CoverageDetailDto';

/**
 * Détail des garanties santé
 * @export
 * @interface SimulationCoveragesDto
 */
export interface SimulationCoveragesDto {
    /**
     * 
     * @type {CoverageDetailDto}
     * @memberof SimulationCoveragesDto
     */
    hospitalization?: CoverageDetailDto;
    /**
     * 
     * @type {CoverageDetailDto}
     * @memberof SimulationCoveragesDto
     */
    dental?: CoverageDetailDto;
    /**
     * 
     * @type {CoverageDetailDto}
     * @memberof SimulationCoveragesDto
     */
    optical?: CoverageDetailDto;
    /**
     * 
     * @type {CoverageDetailDto}
     * @memberof SimulationCoveragesDto
     */
    generalPractitioner?: CoverageDetailDto;
    /**
     * 
     * @type {CoverageDetailDto}
     * @memberof SimulationCoveragesDto
     */
    specialist?: CoverageDetailDto;
    /**
     * 
     * @type {CoverageDetailDto}
     * @memberof SimulationCoveragesDto
     */
    alternativeMedicine?: CoverageDetailDto;
    /**
     * 
     * @type {CoverageDetailDto}
     * @memberof SimulationCoveragesDto
     */
    pharmacy?: CoverageDetailDto;
}

/**
 * Check if a given object implements the SimulationCoveragesDto interface.
 */
export function instanceOfSimulationCoveragesDto(value: object): value is SimulationCoveragesDto {
    return true;
}

export function SimulationCoveragesDtoFromJSON(json: any): SimulationCoveragesDto {
    return SimulationCoveragesDtoFromJSONTyped(json, false);
}

export function SimulationCoveragesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimulationCoveragesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'hospitalization': json['hospitalization'] == null ? undefined : CoverageDetailDtoFromJSON(json['hospitalization']),
        'dental': json['dental'] == null ? undefined : CoverageDetailDtoFromJSON(json['dental']),
        'optical': json['optical'] == null ? undefined : CoverageDetailDtoFromJSON(json['optical']),
        'generalPractitioner': json['generalPractitioner'] == null ? undefined : CoverageDetailDtoFromJSON(json['generalPractitioner']),
        'specialist': json['specialist'] == null ? undefined : CoverageDetailDtoFromJSON(json['specialist']),
        'alternativeMedicine': json['alternativeMedicine'] == null ? undefined : CoverageDetailDtoFromJSON(json['alternativeMedicine']),
        'pharmacy': json['pharmacy'] == null ? undefined : CoverageDetailDtoFromJSON(json['pharmacy']),
    };
}

export function SimulationCoveragesDtoToJSON(json: any): SimulationCoveragesDto {
    return SimulationCoveragesDtoToJSONTyped(json, false);
}

export function SimulationCoveragesDtoToJSONTyped(value?: SimulationCoveragesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hospitalization': CoverageDetailDtoToJSON(value['hospitalization']),
        'dental': CoverageDetailDtoToJSON(value['dental']),
        'optical': CoverageDetailDtoToJSON(value['optical']),
        'generalPractitioner': CoverageDetailDtoToJSON(value['generalPractitioner']),
        'specialist': CoverageDetailDtoToJSON(value['specialist']),
        'alternativeMedicine': CoverageDetailDtoToJSON(value['alternativeMedicine']),
        'pharmacy': CoverageDetailDtoToJSON(value['pharmacy']),
    };
}

